import type { CardItem } from './types';

export type NormalizedCard = CardItem & { timestamp: number };

export function normalizeCards(cards: CardItem[] | null | undefined): NormalizedCard[] {
  if (!Array.isArray(cards)) return [];
  return cards
    .filter((card) => card && typeof card === 'object')
    .map((card) => ({
      image: String(card.image || ''),
      title: String(card.title || ''),
      timestamp: Number.isFinite(Number(card.timestamp)) ? Number(card.timestamp) : 0,
    }))
    .sort((a, b) => a.timestamp - b.timestamp);
}

/**
 * Last card whose timestamp is <= currentTime.
 * Times before the first timestamp still select card 0.
 */
export function activeIndexFromTime(cards: NormalizedCard[], currentTime: number): number {
  if (!cards.length) return 0;
  const t = Number.isFinite(currentTime) ? currentTime : 0;
  let index = 0;
  for (let i = 0; i < cards.length; i += 1) {
    if (cards[i].timestamp <= t) index = i;
    else break;
  }
  return index;
}

/** Leftmost window so `visibleCards` never includes empty slots. */
export function windowStartFromActive(
  activeIndex: number,
  cardCount: number,
  visibleCards: number,
  loop: boolean,
): number {
  const n = Math.max(0, cardCount);
  const visible = Math.max(1, visibleCards);
  if (n <= visible) return 0;
  const active = Math.max(0, activeIndex);
  if (loop) return active;
  return Math.min(active, n - visible);
}

/** Seconds from 0 until the strip should wrap when `loop` is on. */
export function loopPeriodSeconds(cards: NormalizedCard[]): number {
  if (cards.length < 2) return Math.max(1, cards[0]?.timestamp || 1);
  const last = cards[cards.length - 1].timestamp;
  const prev = cards[cards.length - 2].timestamp;
  const gap = Math.max(0.25, last - prev);
  return last + gap;
}

export function wrapInternalTime(time: number, period: number): number {
  if (!(period > 0)) return Math.max(0, time);
  const t = time % period;
  return t < 0 ? t + period : t;
}
